<div class="container">
    <nav aria-label="breadcrumb" class="breadCust">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/corporate/master">Master Module</a></li>
            <li class="breadcrumb-item"><a routerLink="/corporate/thememaster">Theme Master</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{headers}} Theme</li>

        </ol>
    </nav>
</div>

<app-theme-form [isComponentLoad]="true" ></app-theme-form>
